/**
 * @file        src/layout/NavTooltip.jsx
 * @description Floating tooltip shown next to collapsed-sidebar icons. JS
 *              from the design positions it via showNavTip/hideNavTip; here
 *              it's a single fixed element wired up by Sidebar's hover events.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
import React from 'react';

export default function NavTooltip() {
  return (
    <div
      id="navTip"
      className="hidden fixed z-[70] -translate-y-1/2 px-3 py-1.5 rounded-lg bg-panel border border-line text-ink text-[13px] font-medium whitespace-nowrap shadow-2xl pointer-events-none"
    />
  );
}
